import { render } from "./BuySellTable.vue?vue&type=template&id=122cdc2e&scoped=true"
import script from "./BuySellTable.vue?vue&type=script&lang=js"
export * from "./BuySellTable.vue?vue&type=script&lang=js"

import "./BuySellTable.vue?vue&type=style&index=0&id=122cdc2e&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122cdc2e"]])

export default __exports__